import { render, staticRenderFns } from "./RenderRuleGoJsonMessage.vue?vue&type=template&id=13cd6df8"
import script from "./RenderRuleGoJsonMessage.vue?vue&type=script&lang=js"
export * from "./RenderRuleGoJsonMessage.vue?vue&type=script&lang=js"
import style0 from "./RenderRuleGoJsonMessage.vue?vue&type=style&index=0&id=13cd6df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports